const booking = {
    familyRules: {
        title: 'Regole per Viaggi Famiglia',
        maxTwoAdults: 'Sono ammessi massimo 2 adulti (da 16 anni in su)',
        moreThanTwoAdultsAdvice: 'Se hai più di 2 adulti, ti consigliamo di fare prenotazioni separate',
        atLeastOneAdult: 'Almeno un adulto (da 18 anni in su) deve essere presente nel viaggio'
    },
    // CTA on TripDetailsPage before opening the booking form
    startBooking: 'Inizia Prenotazione',
    startBookingDescription: 'Seleziona le date, il numero di partecipanti e inserisci i dettagli',
    // Steps
    stepQuotes: 'Seleziona Quote',
    stepParticipants: 'Informazioni Partecipanti',
    stepAddress: 'Informazioni di Contatto',
    stepReview: 'Rivedi Prenotazione',
    stepPackage: 'Seleziona pacchetto',

    // Quotes Selection
    selectQuotes: 'Seleziona il numero di quote',
    selectQuotesDescription: 'Scegli quante persone parteciperanno al viaggio (da 1 a 30)',
    selectPackageTitle: 'Seleziona pacchetto',
    selectPackageSubtitle: 'Scegli il tipo di partecipazione in base al numero di partecipanti',
    numberOfQuotes: 'Numero di quote',
    pricePerQuote: 'Prezzo per quota',
    pricePerPerson: 'Prezzo per persona',
    depositPerPersonLabel: 'Acconto per persona',
    totalAmount: 'Importo totale',
    depositAmount: 'Acconto',
    balanceAmount: 'Saldo',
    insufficientSpotsForPackage: 'Non disponibile: servono {required} posti ma ne rimangono solo {available}',
    family: 'Family',
    people: 'Persone',

    // Participants
    participantsInfo: 'Informazioni Partecipanti',
    participantsDescription: 'Inserisci nome e cognome di tutti i partecipanti',
    participant: 'Partecipante',
    firstName: 'Nome',
    lastName: 'Cognome',
    age: 'Età',
    child: 'Bambino',
    adult: 'Adulto',

    // Address
    contactInfo: 'Informazioni di Contatto',
    contactDescription: 'Inserisci il tuo indirizzo per la fatturazione',
    address: 'Indirizzo',
    city: 'Città',
    postalCode: 'CAP',
    country: 'Paese',
    phone: 'Telefono',

    // Review
    reviewBooking: 'Rivedi Prenotazione',
    reviewDescription: 'Controlla tutti i dettagli prima di procedere al pagamento',
    tripDetails: 'Dettagli Viaggio',
    participants: 'Partecipanti',
    paymentSummary: 'Riepilogo Pagamento',

    // Navigation
    previous: 'Precedente',
    next: 'Successivo',
    cancel: 'Annulla',
    proceedToPayment: 'Procedi al Pagamento',
    processing: 'Elaborazione...',

    // Validation
    validationError: 'Per favore completa tutti i campi obbligatori',
    createError: 'Errore nella creazione della prenotazione. Riprova.',
    alreadyBookedError: 'Hai già una prenotazione per questo viaggio. Puoi prenotare solo un viaggio per utente.',

    // Date Selection
    selectDate: 'Seleziona Data',
    selectTripDate: 'Seleziona la data del viaggio',
    selectDateDescription: 'Scegli tra le date disponibili per',
    noDatesAvailable: 'Nessuna data disponibile per questo viaggio',
    datesComingSoon: 'Le date di questo viaggio saranno presto comunicate!',
    followSocialForUpdates: 'Seguici sui nostri social per aggiornamenti',
    spotsAvailable: 'posti disponibili',
    spotsTotal: 'su',
    spotsTotalLabel: 'totali',
    fullyBooked: 'Completo',
    spotsRemaining: 'posti rimanenti',

    // Address info
    addressSavedInfo: 'Verranno utilizzati i tuoi dati di indirizzo salvati. Puoi modificarli qui sotto.',
    addressWillBeSaved: 'Questi dati di indirizzo verranno salvati nel tuo account per prenotazioni future.',

    // Footer note
    childrenDefinition: '* per bambino si intende minore di 16 anni.',

    // Country options
    countryOther: 'Altro',

    // Discount Code
    discountCode: {
        title: 'Codice Sconto',
        enterCode: 'Inserisci codice sconto',
        placeholder: 'Inserisci codice sconto',
        apply: 'Applica',
        validating: 'Validazione...',
        applied: 'Codice applicato',
        appliedMessage: 'Codice sconto applicato! Sconto del {percent}%',
        invalid: 'Codice sconto non valido',
        validationError: 'Errore nella validazione del codice sconto',
        removed: 'Codice sconto rimosso',
        selectDateFirst: 'Seleziona prima una data per il viaggio',
        enterCodeError: 'Inserisci un codice sconto',
    },

    // Trip Types
    tripTypes: {
        solo: 'Solo Trip',
        duo: 'Duo Trip',
        trio: 'Family - 3 Persone',
        pocker: 'Family - 4 Persone',
    },

    // Trip Descriptions
    tripDescriptions: {
        solo: 'Viaggio singolo',
        duo: 'Viaggio in coppia',
        trio: 'Viaggio famiglia (2 adulti + 1 bambino*)',
        pocker: 'Viaggio famiglia (2 adulti + 2 bambini*)',
    },

    // Review Step Labels
    selectedDate: 'Data selezionata',
    dateLabel: 'Data',
    participantNumber: 'Partecipante',
    nameLabel: 'Nome',
    lastNameLabel: 'Cognome',
    ageLabel: 'Età',
    yearsOld: 'anni',
    addressLabel: 'Indirizzo',
    cityLabel: 'Città',
    postalCodeLabel: 'CAP',
    countryLabel: 'Paese',
    phoneLabel: 'Telefono',
    originalPrice: 'Prezzo originale',
    discount: 'Sconto',
    remove: 'Rimuovi',

    // Errors
    error: {
        loadingDates: 'Errore nel caricamento delle date disponibili',
        noDatesAvailable: 'Nessuna data disponibile per questo viaggio',
        loadingTripConfig: 'Errore nel caricamento della configurazione dei viaggi',
        selectDateForTrip: 'Seleziona una data per il viaggio',
        noPriceAvailable: 'Nessun prezzo disponibile per questo viaggio',
    },

    // Validation Messages
    validation: {
        atLeastOneAdult18: 'Almeno un partecipante deve avere 18 anni o più',
        familyTripNeedsChild: 'Per i viaggi famiglia (3-4 persone) è necessario almeno un bambino sotto i 16 anni',
        familyTripMaxAdults: 'Per i viaggi famiglia (3-4 persone) sono ammessi massimo 2 adulti (16+ anni). Hai inserito {count} adulti.',
        fillAllParticipantFields: 'Compila tutti i campi obbligatori per i partecipanti',
        fillAllAddressFields: 'Compila tutti i campi obbligatori per l\'indirizzo',
        selectDateToContinue: 'Seleziona una data per continuare',
        selectParticipationType: 'Seleziona un tipo di partecipazione per continuare',
    },
};

export default booking;
